var $ = jQuery.noConflict();
var contactFormGate = false;

/* DOCUMENT.READY FUNCTIONS */
$(document).ready(function() {
    svg4everybody();
    /*
     *  INITIALIZE GALLERIES
     */
    if ( $('.page-gallery').length > 0 ) {
        $('.page-gallery').each(function( index ) {
            let generatedID = 'gallery_' + index;
            galleryInit( $(this), generatedID );
        });
    }

    /*
     * INITIALIZE HOME GALLERY
     */
    if (('#home-tab-intros').length > 0) {
        $('#home-tab-intros').each(function( index ) {
            let generatedID = 'home_gallery_' + index;
            homeGalleryInit ( $(this), generatedID);
        });
    }

    $(".searchBtn a").unbind().click(function(){
      console.log('yo');
        $('.desktop-search').toggleClass('active');
    });



    /*
     * FEATURED MEALS MODALS
     */
    if ( $('#home-samples').length > 0 ) {
        $('.home-sample-modal').hide();

        $('.home-sample > a').click(function(event) {
            event.preventDefault();
            $("body").append("<div id='lightbox-layover'></div>");
            $("#lightbox-layover").css("z-index","9999999");
            $(this).parent().children('.home-sample-modal').clone().appendTo('body').show().attr('id', 'lightbox-content');
            $("#lightbox-content").css("z-index","999999999");

            // Dismiss lightbox
            $('#lightbox-layover, #lightbox-content').click(function() {
                $("#lightbox-layover").fadeOut(300);
                $("#lightbox-content").fadeOut(300);
                setTimeout(function() {
                    $("#lightbox-layover").remove();
                    $("#lightbox-content").remove();
                }, 300);
            });
        });
    }

    /*
     * FOOD CALENDAR MOBILE SLICK
     */
    if ( $('.food-calendar-mobile-container').length > 0 ) {
        $('.food-calendar-mobile-container').each( function(index) {
            let generatedID = 'meal_gallery_' + index;
            mealGalleryInit( $(this), generatedID );
        });
    }


    $('#mobile-menu-btn').unbind().click(function(){
      mobile_menu_toggle();
      console.log('stuff');
    });

    jQuery('#mobile-menu .menu-item a').unbind().click(function(){
      if($(this).siblings('.child-items').length != 0){
        console.log('clciked');
        var $this = jQuery(this).parent();
        $this.toggleClass('active');
        jQuery('#mobile-menu').toggleClass('item-selected');
        if($this.attr('menu-item') != 1 && $this.attr('menu-item') != 0){
          jQuery('#mobile-menu .child-items').each(function(e){
            $(this).css('margin-top', ($this.height()/2 - $(this).height()/2) + 'px' );
          });
        }else{
          jQuery('#mobile-menu .child-items').css('margin-top', '0');
        }
      }
    });

    $("#mobile-menu .searchBtn a").unbind().click(function(){
      console.log('yo');
      $(this).siblings('.mobile-search').toggleClass('active');
    });

    $("#mobile-menu .mobile-close-search").unbind().click(function(){
      $('.mobile-search').removeClass('active');
    });

    /*
     * Prevent form spam submit
     */
    $('.ctct-form').submit( function(event) {
        if ( contactFormGate ) {
            event.preventDefault();
        } else {
            contactFormGate = true;
        }
    });

    /*
     * Scroll to form submit message if it's not in view
     */
    // if ($('.ctct-message')) {
    //     console.log("scrolling to submit message...");
    //     let anchor = $('.ctct-message').get(0).getBoundingClientRect().top;
    //     $('body, html').animate({
    //         scrollTop: anchor,
    //     }, 2000);
    // }

});

/* DOCUMENT READY END */

function galleryInit( $galleryContainer, id ) {
    // console.log( $galleryContainer );
    // console.log( id );
    let $leftGallery = $galleryContainer.children('.page-gallery-left').children('.page-gallery-left-slides-container').eq(0);
    let $rightGallery = $galleryContainer.children('.page-gallery-right').children('.page-gallery-right-slides-container').eq(0);
    let $navTabs = $galleryContainer.children('.page-gallery-right').children('.page-gallery-right-navigation-scroller-container').children('.page-gallery-right-navigation-scroller').children('.page-gallery-right-navigation');
    let $navTabsScroll = $navTabs.parent().get(0);

    $leftGallery.attr('id', id);
    $rightGallery.attr('id', 'right_' + id);
    $navTabs.attr('id', 'nav_for_' + id);

    // Captions gallery
    $leftGallery.slick({
        fade: true,
        arrows: false,
        asNavFor: '#right_' + id,
    });

    // Image gallery
    $rightGallery.slick({
        arrows: false,
        dots: true,
        asNavFor: '#' + id,
        appendDots: $rightGallery.parent(),
        dotsClass: 'tab-intro-tabs',
        appendDots: '#nav_for_' + id,
        adaptiveHeight: true,
    });

    // Update slide indicator
    $navTabs.find('li').eq(0).addClass('active');
    updateGalleryIndicator( $navTabs );

    // Update slide indicator whenever gallery slide changes
    $rightGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $navTabs.find('li').removeClass('active');
        $navTabs.find('li').eq(nextSlide).addClass('active');
        updateGalleryIndicator( $navTabs );
    });

    // Hover states
    $navTabs.find('li').mouseover( function() {
        updateGalleryIndicator( $navTabs, $(this) );
    });

    $navTabs.find('li').mouseout( function() {
        updateGalleryIndicator( $navTabs );
    });

    // Scroll indication
    if ($navTabsScroll.scrollWidth > $navTabsScroll.offsetWidth) {
        $($navTabsScroll).parent().addClass('scrollable-right');
        $navTabsScroll.addEventListener('scroll', function() {
            let offsetScroll = $(this).get(0).scrollLeft;
            let maxWidth = $(this).get(0).scrollWidth - $(this).get(0).offsetWidth;
            // console.log("OFFSET: " + offsetScroll + "\nMAXWIDTH: " + maxWidth);

            if ( offsetScroll > 10 ) {
                $(this).parent().addClass('scrollable-left');
            } else {
                $(this).parent().removeClass('scrollable-left');
            }

            if ( offsetScroll < maxWidth - 10 ) {
                $(this).parent().addClass('scrollable-right');
            } else {
                $(this).parent().removeClass('scrollable-right');
            }

        });
    }


}

function homeGalleryInit( $galleryContainer, id ) {
    let $leftGallery = $galleryContainer.children('#tab-intro-left').children('.home-gallery-content-slides').eq(0);
    let $rightGallery = $galleryContainer.children('#tab-intro-right').children('.home-gallery-image-slides').eq(0);
    let $navTabs = $galleryContainer.children('#tab-intro-left').children('#tab-intro-tabs').children('.wide');

    $leftGallery.attr('id', id);
    $rightGallery.attr('id', id+'_image');

    $leftGallery.slick({
        fade: true,
        arrows: false,
        asNavFor: '#' + id + '_image',
        pauseOnFocus: true,
        pauseOnHover: true,
    });

    // ensure that tab intro right takes up 100% of container because flexbox doesnt know how to act and stretch uses initial values
    $('#tab-intro-right').hide();
    $('#tab-intro-right').css('height', $('#tab-intro-left').innerHeight());
    $('#tab-intro-right').show();

    $rightGallery.slick({
        fade: true,
        arrows: false,
        asNavFor: '#' + id,
        autoplay: true,
        autoplaySpeed: 8000,
        adaptiveHeight: false,
        pauseOnFocus: true,
        pauseOnHover: true,
    });

    $rightGallery.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $navTabs.removeClass('active');
        $navTabs.eq(nextSlide).addClass('active');
        updateGalleryIndicator( $navTabs.parent() );
     });

    $navTabs.eq(0).addClass('active');
    updateGalleryIndicator( $navTabs.parent() );

    // Hover states
    $navTabs.mouseover( function() {
        updateGalleryIndicator( $navTabs.parent(), $(this) );
    });

    $navTabs.mouseout( function() {
        updateGalleryIndicator( $navTabs.parent() );
    });

    $navTabs.click(function() {
        let slide = $(this).attr('tab');
        $('#'+id+'_image').slick('slickGoTo', slide-1);
    });
}

function updateGalleryIndicator( $tabs, $target ) {
    let $indicator = $tabs.children('.slide-indicator');
    let $activeSlide = $tabs.find('.active');
    let posX = 0;
    let width = 0;

    if ( $target ) {
        posX = $target.position().left;
        width = $target.outerWidth();
    } else {
        posX = $activeSlide.position().left;
        width = $activeSlide.outerWidth();
    }

    $indicator.css('left', posX);
    $indicator.css('width', width);
};

function mealGalleryInit( $galleryContainer, id ) {
    let $navigationButtons = $galleryContainer.children('.food-calendar-mobile-navigation').children('.food-calendar-mobile-button');
    let $daysGallery = $galleryContainer.children('.food-calendar-mobile-gallery');

    $daysGallery.attr('id', id);
    $daysGallery.slick({
        fade: true,
        arrows: false,
        adaptiveHeight: true,
        autoplay: false,
    });

    $navigationButtons.eq(0).addClass('active');


    $galleryContainer.children('.food-calendar-mobile-navigation').children('.food-calendar-mobile-button').click(function() {
        $('.food-calendar-mobile-button').removeClass('active');
        $(this).addClass('active');

        let slide = $(this).attr('tab');
        $('#'+id).slick('slickGoTo', slide-1);
    });
}

function mobile_menu_toggle() {
  $('#mobile-menu, #mobile-menu-btn').toggleClass('active');

}



// WEBPACK FOOTER //
// ./js/script.js